export function EditorDisclaimer() {
  return (
    <p className="text-xs text-muted-foreground/60 text-center pb-2">
      You are responsible for verifying all pricing and data before sending. QuoTrak is not liable for any financial outcomes.
    </p>
  );
}
